'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactClickdrag = require('react-clickdrag');

var _reactClickdrag2 = _interopRequireDefault(_reactClickdrag);

var _reactDom = require('react-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./DragArea.pcss');

var DragArea = function (_Component) {
  _inherits(DragArea, _Component);

  function DragArea(props) {
    _classCallCheck(this, DragArea);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DragArea).call(this, props));

    _this.state = {
      x: props.initX || 0,
      y: props.initY || 0,
      lastX: props.initX || 0,
      lastY: props.initY || 0
    };
    return _this;
  }

  _createClass(DragArea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.preventDefault) {
        var node = (0, _reactDom.findDOMNode)(this);
        node.addEventListener('mousedown', function (e) {
          e.preventDefault();
        });

        /*
        node.addEventListener('click', e => {
          const { moveDeltaX, moveDeltaY } = this.props.dataDrag;
          console.log({...this.props.dataDrag});
           if ((moveDeltaY !== 0) || (moveDeltaX !== 0)) {
            e.stopPropagation();
          }
        });
        */
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var dataDragChanged = nextProps.dataDrag !== this.props.dataDrag;
      var willMove = nextProps.dataDrag.isMoving;
      var moving = this.props.dataDrag.isMoving;
      var mouseDown = this.props.dataDrag.isMouseDown;

      if (dataDragChanged) {
        if (!this.props.dataDrag.isMoving && nextProps.dataDrag.isMoving) {
          this.notifyDragStart();
        }
        if (this.props.dataDrag.isMouseDown && !nextProps.dataDrag.isMouseDown) {
          this.notifyDragStop();
        }

        var _state = this.state;
        var x = _state.x;
        var y = _state.y;
        var lastX = _state.lastX;
        var lastY = _state.lastY;


        if (willMove) {
          var dx = nextProps.dataDrag.moveDeltaX;
          var dy = nextProps.dataDrag.moveDeltaY;

          var _getShiftedCoordinate = this.getShiftedCoordinates({ lastX: lastX, lastY: lastY, dx: dx, dy: dy });

          var newX = _getShiftedCoordinate.newX;
          var newY = _getShiftedCoordinate.newY;


          this.setState({ x: newX, y: newY });
          this.props.onDrag({ x: newX, y: newY });
        } else {
          this.setState({ lastX: x, lastY: y });
        }
      } else {
        var initX = nextProps.initX;
        var initY = nextProps.initY;
        var _props = this.props;
        var oldInitX = _props.initX;
        var oldInitY = _props.initY;


        if (initX !== oldInitX || initY !== oldInitY) {
          // if init coords have changed
          this.setState({
            x: initX, y: initY,
            lastX: initX, lastY: initY
          });
          this.props.onDrag({ x: initX, y: initY });
        }
      }

      if (mouseDown && !moving) {
        this.setLastCoords(nextProps.lastX, nextProps.lastY);
      }
    }
  }, {
    key: 'getShiftedCoordinates',
    value: function getShiftedCoordinates(_ref) {
      var lastX = _ref.lastX;
      var lastY = _ref.lastY;
      var dx = _ref.dx;
      var dy = _ref.dy;
      var reversed = this.props.reversed;


      var newX = undefined;
      var newY = undefined;

      if (!reversed) {
        newX = lastX + dx;
        newY = lastY + dy;
      } else {
        newX = lastX - dx;
        newY = lastY - dy;
      }

      return { newX: newX, newY: newY };
    }
  }, {
    key: 'setLastCoords',
    value: function setLastCoords(lastX, lastY) {
      if (!this.props.traceLast) return;
      this.setState({ lastX: lastX, lastY: lastY });
    }
  }, {
    key: 'notifyDragStart',
    value: function notifyDragStart() {
      if (this.props.onDragStart) this.props.onDragStart();
    }
  }, {
    key: 'notifyDragStop',
    value: function notifyDragStop() {
      if (this.props.onDragStop) this.props.onDragStop();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: styles.dragArea },
        this.props.children
      );
    }
  }]);

  return DragArea;
}(_react.Component);

var dragConfig = {
  onDragStart: function onDragStart() {
    if (document) {
      document.body.style.cursor = 'move';
    }
  },
  onDragStop: function onDragStop() {
    if (document) {
      document.body.style.cursor = '';
    }
  }
};

exports.default = (0, _reactClickdrag2.default)(DragArea, dragConfig);


DragArea.propTypes = {
  initX: _react.PropTypes.number.isRequired,
  initY: _react.PropTypes.number.isRequired,
  onDrag: _react.PropTypes.func.isRequired,
  onDragStart: _react.PropTypes.func,
  onDragStop: _react.PropTypes.func,

  children: _react.PropTypes.any.isRequired,
  dataDrag: _react.PropTypes.object,
  preventDefault: _react.PropTypes.bool,
  traceLast: _react.PropTypes.bool
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectView/Viewport/DragArea.js
// module id = 602
// module chunks = 1